export enum DomainType {
  IPBX = 'IPBX',
  RESIDENTIAL = 'RESIDENTIAL',
  ROUTING = 'ROUTING',
  MIXED = 'MIXED',
}
